export const GET_PRODUCTS = "GET_PRODUCTS"
export const GET_PRODUCTS_SUCCESS = "GET_PRODUCTS_SUCCESS"
export const GET_PRODUCTS_FAIL = "GET_PRODUCTS_FAIL"

export const GET_PRODUCT = "GET_PRODUCT"
export const GET_PRODUCT_SUCCESS = "GET_PRODUCT_SUCCESS"
export const GET_PRODUCT_FAIL = "GET_PRODUCT_FAIL"

export const CREATE_PRODUCT = "CREATE_PRODUCT"
export const CREATE_PRODUCT_SUCCESS = "CREATE_PRODUCT_SUCCESS"
export const CREATE_PRODUCT_FAIL = "CREATE_PRODUCT_FAIL"

export const UPDATE_PRODUCT = "UPDATE_PRODUCT"
export const UPDATE_PRODUCT_SUCCESS = "UPDATE_PRODUCT_SUCCESS"
export const UPDATE_PRODUCT_FAIL = "UPDATE_PRODUCT_FAIL"

export const DELETE_PRODUCT = "DELETE_PRODUCT"
export const DELETE_PRODUCT_SUCCESS = "DELETE_PRODUCT_SUCCESS"
export const DELETE_PRODUCT_FAIL = "DELETE_PRODUCT_FAIL"

// Image endpoints
export const ATTACH_PRODUCT_IMAGE = "ATTACH_PRODUCT_IMAGE"
export const ATTACH_PRODUCT_IMAGE_SUCCESS = "ATTACH_PRODUCT_IMAGE_SUCCESS"
export const ATTACH_PRODUCT_IMAGE_FAIL = "ATTACH_PRODUCT_IMAGE_FAIL"

export const UPLOAD_PRODUCT_IMAGE = "UPLOAD_PRODUCT_IMAGE"
export const UPLOAD_PRODUCT_IMAGE_SUCCESS = "UPLOAD_PRODUCT_IMAGE_SUCCESS"
export const UPLOAD_PRODUCT_IMAGE_FAIL = "UPLOAD_PRODUCT_IMAGE_FAIL"

// Inventory endpoint
export const UPDATE_PRODUCT_INVENTORY = "UPDATE_PRODUCT_INVENTORY"
export const UPDATE_PRODUCT_INVENTORY_SUCCESS = "UPDATE_PRODUCT_INVENTORY_SUCCESS"
export const UPDATE_PRODUCT_INVENTORY_FAIL = "UPDATE_PRODUCT_INVENTORY_FAIL"

export const CLEAR_PRODUCT_ERROR = "CLEAR_PRODUCT_ERROR"
export const CLEAR_SELECTED_PRODUCT = "CLEAR_SELECTED_PRODUCT"